import Moment from 'moment'

export function friendlyDateFilter (d) {
  return Moment(d).format('DD-MM-YYYY')
}

export function formatCalendarDay (d) {
  if (!d) throw new Error('invalid date input: ' + d)

  return Moment(d).calendar(null, {
    lastDay: function () {
      return '[gisteren]'
    },

    sameDay: function () {
      return '[vandaag]'
    },

    nextDay: function () {
      return '[morgen]'
    },

    nextWeek: function () {
      return 'dddd'
    },

    lastWeek: function () {
      return '[afgelopen] dddd'
    },

    sameElse: function () {
      return 'D MMMM YYYY'
    }
  })
}

export function formatCalendarDayTime (d) {
  if (!d) throw new Error('invalid date input: ' + d)

  return Moment(d).calendar(null, {
    lastDay: function () {
      return '[gisteren] HH:mm'
    },

    sameDay: function () {
      return '[vandaag] HH:mm'
    },

    nextDay: function () {
      return '[morgen]'
    },

    nextWeek: function () {
      return 'dddd'
    },

    lastWeek: function () {
      return '[afgelopen] dddd'
    },

    sameElse: function () {
      return 'D MMMM YYYY'
    }
  })
}
